import { useEffect, useState } from "react";
import ImageUploader2 from "./ImageUploader2";
import Resizer from "react-image-file-resizer";
import { Field, Form as FinalForm } from "react-final-form";
import Swal from "sweetalert2";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AddBlogForm = (props) => {
  const {
    loadingCallback,
    navigate,
    setShowPaymentModal,
    setShowModal,
    isOpen,
    title,
    //setWarningMessage,
    type,
    formData,
    setFormData,
    refetch,
    getBlogList,
  } = props;

  const token = localStorage.getItem("token");

  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState("");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
    }
  };

  // const handleUpload = async () => {
  //   if (!image) {
  //     alert("Please select an image first.");
  //     return;
  //   }

  //   console.log("Image File:", image);
  //   console.log("Type of Image:", typeof image);
  //   console.log("Is instance of File?", image instanceof File);

  //   const formImageData = new FormData();
  //   formImageData.append("file_name", image); // Appending the selected image file
  //   console.log("formImageData", formImageData);

  //   // Log each entry in FormData
  //   for (let pair of formImageData.entries()) {
  //     console.log(`Key: ${pair[0]}, Value:`, pair[1]);
  //   }

  //   try {
  //     // Step 1: Upload the image
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API_URL}file-upload`,
  //       formImageData,
  //       {
  //         headers: {
  //           authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     console.log("Image uploaded successfully:", response.data.path);

  //     // Step 2: Update form data with the image URL received from the API
  //     const updatedFormData = {
  //       ...formData,
  //       image: response.data.path, // Save the image path in form data
  //     };

  //     // Step 3: Send the updated form data (including image URL) to save the blog
  //     const blogResponse = await axios.post(
  //       `${process.env.REACT_APP_API_URL}save-latest-blog`,
  //       updatedFormData,
  //       {
  //         headers: {
  //           authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("Blog saved successfully:", blogResponse.data);

  //     // Step 4: Update UI states
  //     setImageUrl(response.data.path);
  //     getBlogList();
  //     alert("Image and blog saved successfully!");
  //   } catch (error) {
  //     console.error("Error in uploading image or saving blog:", error);
  //     alert("An error occurred. Please try again!");
  //   }
  // };

  const handleUpload = async () => {
  if (!image) {
    alert("Please select an image first.");
    return;
  }

  requestAnimationFrame(async () => {
    const formImageData = new FormData();
    formImageData.append("file_name", image);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}file-upload`,
        formImageData,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      const updatedFormData = {
        ...formData,
        image: response.data.path,
      };

      const blogResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}save-latest-blog`,
        updatedFormData,
        {
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Now safely update UI
      setImageUrl(response.data.path);
      getBlogList();

      alert("Image and blog saved successfully!");
      setShowModal(false);

    } catch (error) {
      console.error("Error in uploading image or saving blog:", error);
      alert("An error occurred. Please try again!");
    }
  });
};

  return (
    <div className="duration-500 w-[3/4] h-[3/4]">
      <div className="w-full relative">
        <label className="absolute font-nunito text-xs text-[#102048] -top-[7px] left-[12px] bg-white px-1 font-semibold">
          Title
        </label>
        <input
          type="text"
          name="title"
          placeholder="Title"
          onChange={(e) =>
            setFormData({
              ...formData,
              title: e.target.value,
            })
          }
          className="input input-bordered border-[#C1CFEF] border-[1px] w-full mb-[10px] focus:outline-none rounded-xl bg-white"
        />
      </div>
      <div className="flex flex-col ">
        {/* <div className="w-full relative mt-2">
          <label className="absolute font-nunito text-xs text-[#102048]  left-[12px] top-[-7px] bg-white px-1 font-semibold">
            Description
          </label>
          <textarea
            type="text"
            name="description"
            onChange={(e) =>
              setFormData({
                ...formData,
                description: e.target.value,
              })
            }
            placeholder="Description"
            className="input input-bordered border-[#C1CFEF] border-[1px] focus:outline-none  w-full  h-20 pt-2 rounded-xl bg-white resize-none"
          />
        </div> */}
        <div className="w-full relative mt-2">
          <label className="absolute font-nunito text-xs text-[#102048] left-[12px] top-[-7px] bg-white px-1 font-semibold">
            Description
          </label>
          <div className="mt-4">
            <ReactQuill
              value={formData.description || ""}
              onChange={(value) =>
                setFormData({
                  ...formData,
                  description: value,
                })
              }
              className="bg-white"
              modules={{
                toolbar: [
                  [{ header: [1, 2, 3, false] }],
                  ["bold", "italic", "underline", "strike"],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["link", "image"],
                  ["clean"],
                ],
              }}
              formats={[
                "header",
                "bold",
                "italic",
                "underline",
                "strike",
                "list",
                "bullet",
                "link",
                "image",
              ]}
            />
          </div>
        </div>

        <div className="flex flex-col ">
          <div className="w-full relative mt-2">
            <div className="md:pl-3">
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
              />
              {image && (
                <img
                  src={URL.createObjectURL(image)}
                  alt="Preview"
                  className="w-32 h-32 mt-2"
                />
              )}
            </div>
          </div>
        </div>

        <div className="flex">
          <div className="w-full relative mt-2 md:pl-3">
            <input
              defaultChecked
              type="checkbox"
              id="product"
              name="have_variant"
              //checked={formData?.status ? formData?.status : 1} // Bind to the boolean value in `formData`
              className="rounded-[6px]"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  status: e.target.checked ? 1 : 0,
                })
              } // Use the updated `handleChange` function
            />
            <span className="text-[#91919F] ml-2 ">Active Status</span>
          </div>{" "}
        </div>

        <div>
          <button
            onClick={() => handleUpload()}
            className="cursor-pointer w-full mt-4 bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBlogForm;
